@keyframes fromleft {
  0% {
    background-position: right;
  }
}

.shine {
  background-image: linear-gradient(103deg, transparent 33%, rgba(255, 255, 255, 0.6) 50%, transparent 66%) !important;
  background-size: 300% 100%;
  animation: fromleft 1.5s infinite;
}

.skeleton-item {
  background-color: var(--clrs-bg-dynamic-entry-skeleton);
}

.skeleton-item--inverse {
  background-color: var(--clrs-bg-dynamic-entry-skeleton-inverse);
}
